import { render, staticRenderFns } from "./trainManage.vue?vue&type=template&id=2abd90ee&"
import script from "./trainManage.vue?vue&type=script&lang=js&"
export * from "./trainManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports